import React, { useState, useEffect } from 'react';
import './SkeletonInput.css'; // Import the CSS for styling

const SkeletonInput = ({ isLoading ,type=""}) => {
  return (
    <div className="input-wrapper">
      {isLoading ? (
        <div className="skeleton-input" style={{"height":type=="line"? "20px" :"40px"}}></div>
      ) : (
        <input type="text" className="input-field" placeholder="Enter text..." />
      )}
    </div>
  );
};

export default SkeletonInput;
